var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            stripe: "",
            "highlight-current-row": "",
            "tooltip-effect": "dark",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "rsmEmpNo",
              label: _vm.$t("salesKPIManagement.table.rsmEmpNo"),
              width: "120",
              fixed: "",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "rsmEmpName",
              label: _vm.$t("salesKPIManagement.table.rsmEmpName"),
              width: "100",
              fixed: "",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "asmEmpNo",
              label: _vm.$t("salesKPIManagement.table.asmEmpNo"),
              width: "120",
              fixed: "",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "asmEmpName",
              label: _vm.$t("salesKPIManagement.table.asmEmpName"),
              width: "100",
              fixed: "",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "empNo",
              label: _vm.$t("salesKPIManagement.table.empNo"),
              width: "120",
              fixed: "",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "empName",
              label: _vm.$t("salesKPIManagement.table.empName"),
              width: "100",
              fixed: "",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "brand",
              label: _vm.$t("salesKPIManagement.table.brand"),
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "year",
              label: _vm.$t("salesKPIManagement.table.year"),
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "oneSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.JanuaryTargetSales"),
              width: "110",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "twoSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.FebruaryTargetSales"),
              width: "110",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "threeSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.MarchTargetSales"),
              width: "110",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "fourSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.AprilTargetSales"),
              width: "110",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "fiveSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.MayTargetSales"),
              width: "110",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "sixSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.JuneTargetSales"),
              width: "110",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "sevenSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.JulyTargetSales"),
              width: "110",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "eightSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.AugustTargetSales"),
              width: "110",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "nineSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.SeptemberTargetSales"),
              width: "110",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "tenSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.OctoberTargetSales"),
              width: "110",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "elevenSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.NovemberTargetSales"),
              width: "110",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "twelveSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.DecemberTargetSales"),
              width: "110",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "oneEighteenSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.January18TargetSales"),
              width: "130",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "twoEighteenSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.February18TargetSales"),
              width: "130",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "threeEighteenSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.March18TargetSales"),
              width: "130",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "fourEighteenSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.April18TargetSales"),
              width: "130",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "fiveEighteenSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.May18TargetSales"),
              width: "130",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "sixEighteenSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.June18TargetSales"),
              width: "130",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "sevenEighteenSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.July18TargetSales"),
              width: "130",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "eightEighteenSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.August18TargetSales"),
              width: "130",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "nineEighteenSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.September18TargetSales"),
              width: "130",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "tenEighteenSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.October18TargetSales"),
              width: "130",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "elevenEighteenSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.November18TargetSales"),
              width: "130",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "twelveEighteenSalesTargetQty",
              label: _vm.$t("salesKPIManagement.table.December18TargetSales"),
              width: "130",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "errorMsg",
              label: _vm.$t("common.errorInfo"),
              "min-width": "180",
              fixed: "right",
              align: "center",
              "show-overflow-tooltip": "",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total>0",
          },
        ],
        attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
        on: {
          "update:page": function ($event) {
            _vm.currPage = $event
          },
          "update:limit": function ($event) {
            _vm.limit = $event
          },
          pagination: _vm.fetchData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }